export const hasStartedSurvey = (user) => {
    const lastQuestion = user.get('lastQuestion');
    const questionList = user.get('questionList');
    return Number.isInteger(lastQuestion) && lastQuestion <= questionList.length;
};


export const isBatchSurvey = () => {
    return window.location.pathname.includes('engagement');
};

